import * as pdfjs from 'pdfjs-dist/build/pdf.mjs';

type RenderTextLayerParams = {
  container: HTMLElement;
};

type RenderTextLayerTask = {
  promise: Promise<void>;
  cancel: () => void;
};

export const renderTextLayer = ({ container }: RenderTextLayerParams): RenderTextLayerTask => {
  container.innerHTML = '';

  let cancelled = false;
  const promise = Promise.resolve().then(() => {
    if (cancelled) {
      return;
    }
  });

  return {
    promise,
    cancel: () => {
      cancelled = true;
    },
  };
};

export * from 'pdfjs-dist/build/pdf.mjs';

export default {
  ...pdfjs,
  renderTextLayer,
};
